// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  Checkbox,
  CheckboxGroup,
  Heading,
  Select,
  Box,
  Input,
  Center,
  Portal
} from "@chakra-ui/react";
// Custom Components
import { ItemContent } from "components/menu/ItemContent";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import React, { useEffect, useState } from "react";
// Assets
import navImage from "assets/img/layout/Navbar.png";
import { SiGooglesheets } from "react-icons/si";
import { MdFilterAlt, MdCalendarMonth } from "react-icons/md";
import { FaEthereum } from "react-icons/fa";
import routes from "routes.js";
import { ThemeEditor } from "./ThemeEditor";
import { IoHandLeftSharp } from "react-icons/io5";
import { useListContext } from "../../contexts/listContext";
import { sheetDownload } from "components/sheetDownload";
import { BsFileEarmarkBarGraphFill } from "react-icons/bs";
import Report from "views/admin/default/Report";

const Dropdown = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("PAuser"));
    const isAdmin = userInfo?.message?.isAdmin || false;

    if (userInfo?.message?.users) {
      setUsers(userInfo?.message?.users);
      setSelectedUser(userInfo?.message?.result.id);
    }
  }, []);

  const handleUserChange = (userId) => {
    const userInfo = JSON.parse(localStorage.getItem("PAuser"));
    const selectedUserData = users.find((user) => user.id === userId);

    if (selectedUserData) {
      const updatedUserInfo = {
        ...userInfo,
        message: {
          ...userInfo?.message,
          result: selectedUserData,
        },
      };
      localStorage.setItem("PAuser", JSON.stringify(updatedUserInfo));
      setSelectedUser(userId);
      window.location.reload();
    }
  };

  return (
    <Select
      value={selectedUser}
      onChange={(e) => handleUserChange(parseInt(e.target.value))}
      size="sm"
      w="150px"
      variant="filled"
      bg="white"
    >
      {users.map((user) => (
        <option key={user.id} value={user.id}>
          {user.name}
        </option>
      ))}
    </Select>
  );
};

export default function HeaderLinks(props) {
  const { secondary } = props;
  const history = useHistory(); // Get the history object
  const location = useLocation();
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const name = (userInfo?.message?.result?.name || "").toUpperCase();
  const isAdmin = userInfo?.message?.isAdmin || false;
  // const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue(" #E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");
  const [checkedItems, setCheckedItems] = React.useState([]);
  const [checkedKeywords, setCheckedKeywords] = React.useState([]);
  const [checkedVerificationStatus, setCheckedVerificationStatus] = React.useState([]);
  
  const { checkedTextStatus, setCheckedTextStatus } = useListContext();
  const { checkedTextAIStatus, setCheckedTextAIStatus } = useListContext();
  const [textStatusFilter, setTextStatusFilter] = useState([]);

  // const [platforms, setPlatforms] = React.useState([]);
  const [keywords, setKeywords] = React.useState([]);
  const [insertKeyword, setInsertKeyword] = React.useState([]);
  const { list, setList } = useListContext();
  const { checkedPlatforms, setCheckedPlatforms } = useListContext();
  const { verificationStatus, setVerificationStatus } = useListContext();
  const { keywordsList, setKeywordsList } = useListContext();
  const { dateFilter, setDateFilter } = useListContext();
  const [abuseTypes, setAbuseTypes] = React.useState([]);
  const { setAbuse_type, platforms, setPlatforms, checkedAbuseTypes, setCheckedAbuseTypes } = useListContext();
  let userName = JSON.parse(localStorage.getItem("PAuser"));
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  // let calendarOptions = [{ id: 1, name: "Today" }, { id: 2, name: "This week" }, { id: 3, name: "This month" }, { id: 4, name: "This Year" }, { id: 5, name: "Past" }, { id: 0, name: "All" }];
  // 	0: 'today'   1: 'this week'   2: 'last week'   3: 'this month'  4: 'last month'
  // 	5: 'this year'   6: 'last year'   7: 'past'    8: 'All'

  // const fetchPlatform = async () => {
  //   // Get the location object
  //   try {

  //     const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  //     //console.log("param pf", userInfo?.message?.result.id);
  //     const response = await fetch(`${backendUrl}/api/platforms/Filter`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         keyword_ids: 
  //       }),
  //     });

  //     const json = await response.json();

  //     if (response.ok) {
  //       setPlatforms(json);
  //       //console.log('platforms', json);
  //       setCheckedPlatforms(json);
  //       const allPlatformIds = json.map((pf) => pf.id);
  //       setCheckedItems(allPlatformIds);
  //     } else if (response.status === 400) {
  //       //console.log(json);
  //       alert(json.message);
  //     }
  //   } catch (e) {
  //     //console.log("error in fetchProducts");
  //   }
  // };

  const fetchPlatform = async (ids) => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("PAuser"));
      
      const response = await fetch(`${backendUrl}/api/platforms/Filter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          keyword_ids: ids, // Use the passed argument here
        }),
      });

      const json = await response.json();

      if (response.ok) {
        setPlatforms(json);
        setCheckedPlatforms(json);
        const allPlatformIds = json.map((pf) => pf.id);
        setCheckedItems(allPlatformIds);
      } else if (response.status === 400) {
        alert(json.message);
      }
    } catch (e) {
      console.log("error in fetchPlatform", e);
    }
  };


  const getAbuseTypes = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/abuses/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();

      if (response.ok) {
        //console.log("abuses fetched", json);
        setAbuseTypes(json);
        setAbuse_type(json);
        const allAbuseTypeIds = json.map((abuse) => abuse.id);
        setCheckedAbuseTypes(allAbuseTypeIds);
      } else if (response.status === 400) {
        //console.log(json);
        alert(json.message);
      }
      // setStatusUpdate(true)
    } catch (e) {
      //console.log("error in getAbuseTypes", e);
    }
  };


const fetchKeywords = async () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("PAuser"));
      
      const response = await fetch(
        `${backendUrl}/api/keyword/getKeywordsForFilter/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id, 
          }),
        }
      );

      const json = await response.json();

      if (response.ok) {
        setKeywords(json);
        setList(json);
        setInsertKeyword([]);
        
        // Extract IDs
        const allKeywordIds = json.map((kw) => kw.id);
        
        setCheckedKeywords(allKeywordIds);
        setKeywordsList(allKeywordIds);
        
        // CHAINING: Call fetchPlatform immediately with the data
        await fetchPlatform(allKeywordIds);

      } else if (response.status === 400) {
        alert(json.message);
      }
    } catch (e) {
      console.log("error in fetchKeywords", e);
    }
  };



  useEffect(() => {
    // fetchPlatform();
    fetchKeywords();
    getAbuseTypes();
  }, []);

  useEffect(() => {
    const allVerificationIds = updatedVerificationOption.map(
      (opt) => opt.brand_image_check
    );
    setCheckedVerificationStatus(allVerificationIds);
    setVerificationStatus(updatedVerificationOption);
    console.log("allVerificationIds", allVerificationIds);
  }, []);


  const handlePlatformCheck = async (pf) => {
    if (pf === "selectAll") {
      if (checkedItems.length === platforms.length) {
        setCheckedItems([]); // Clear all selections
        setCheckedPlatforms([]);
      } else {
        setCheckedItems(platforms.map((k) => k.id)); // Select all
        setCheckedPlatforms(platforms);
      }
    } else {
      const isChecked = checkedItems.includes(pf.id);
      let newCheckedItems;

      if (isChecked) {
        newCheckedItems = checkedItems.filter((id) => id !== pf.id);
      } else {
        newCheckedItems = [...checkedItems, pf.id];
      }

      setCheckedItems(newCheckedItems);

      // Log checked platform IDs and names
      const checkedPF = platforms.filter((platform) =>
        newCheckedItems.includes(platform.id)
      );
      //console.log('Checked Platforms:', checkedPF.map((platform) => ({ id: platform.id, name: platform.platform_name })));
      // localStorage.removeItem('checkedPF');
      // localStorage.setItem('checkedPF', JSON.stringify(checkedPF.map((platform) => ({ id: platform.id, name: platform.platform_name }))));
      setCheckedPlatforms(checkedPF);
    }
  };

  const handleKeywordCheck = async (pf) => {
    if (pf === "selectAll") {
      // Check if all keywords are selected
      if (checkedKeywords.length === keywords.length) {
        await setCheckedKeywords([]); // Clear all selections
        setList([]);
      } else {
        await setCheckedKeywords(keywords.map((k) => k.id)); // Select all
        setList(keywords);
      }
    } else {
      const isChecked = checkedKeywords.includes(pf.id);
      let newCheckedItems;

      if (isChecked) {
        newCheckedItems = checkedKeywords.filter((id) => id !== pf.id);
      } else {
        newCheckedItems = [...checkedKeywords, pf.id];
      }

      setCheckedKeywords(newCheckedItems);
      localStorage.removeItem("checkedKeywords");
      localStorage.setItem("checkedKeywords", JSON.stringify(newCheckedItems));

      // Log checked platform IDs and names
      const lists = keywords.filter((keyword) =>
        newCheckedItems.includes(keyword.id)
      );
      //console.log('Checked keywords:', lists.map((ele) => ({ id: ele.id, name: ele.name })));
      // localStorage.removeItem('checkedKeywords');
      // localStorage.setItem('checkedKeywords', JSON.stringify(lists.map((ele) => ({ id: ele.id, name: ele.name }))));
      setList(lists);
    }
  };

  const handleVerificationCheck = async (ele) => {
    if (ele === "selectAll") {
      // Check if all keywords are selected
      if (
        checkedVerificationStatus.length === updatedVerificationOption.length
      ) {
        console.log("selectAll ");
        setCheckedVerificationStatus([]); // Clear all selections
        setVerificationStatus([]);
      } else {
        setCheckedVerificationStatus(
          updatedVerificationOption.map((k) => k.brand_image_check)
        ); // Select all
        setVerificationStatus(updatedVerificationOption);
      }
    } else {
      const isChecked = checkedVerificationStatus.includes(
        ele.brand_image_check
      );
      let newCheckedItems;
      if (isChecked) {
        newCheckedItems = checkedVerificationStatus.filter(
          (id) => id !== ele.brand_image_check
        );
      } else {
        newCheckedItems = [...checkedVerificationStatus, ele.brand_image_check];
      }

      console.log("newChecked", newCheckedItems);
      setCheckedVerificationStatus(newCheckedItems);
      // localStorage.removeItem('checked_Verification_Status');
      // localStorage.setItem('checked_Verification_Status', JSON.stringify(newCheckedItems));

      // Log checked platform IDs and names
      const lists = updatedVerificationOption.filter((platform) =>
        newCheckedItems.includes(platform.brand_image_check)
      );
      //console.log('Checked verificationStatus:', lists);
      // localStorage.removeItem('checked_Verification_Status');
      // localStorage.setItem('checked_Verification_Status', JSON.stringify(lists.map((ele) => ({ is_text: ele.is_text, name: ele.name }))));
      setVerificationStatus(lists);
      // //console.log("current Location",location);
    }
  };

  const handleTextStatusCheck = async (ele) => {
    if (ele === "selectAll") {
      if (checkedTextStatus.length === textStatusOptions.length) {
        setCheckedTextStatus([]);
        setTextStatusFilter([]);
      } else {
        setCheckedTextStatus(textStatusOptions.map(opt => opt.value));
        setTextStatusFilter(textStatusOptions);
      }
    } else {
      const isChecked = checkedTextStatus.includes(ele.value);
      let newCheckedItems;

      if (isChecked) {
        newCheckedItems = checkedTextStatus.filter(id => id !== ele.value);
      } else {
        newCheckedItems = [...checkedTextStatus, ele.value];
      }

      setCheckedTextStatus(newCheckedItems);
      const lists = textStatusOptions.filter(item =>
        newCheckedItems.includes(item.value)
      );
      setTextStatusFilter(lists);
    }
  };
  const handleTextAIStatusCheck = async (ele) => {
    if (ele === "selectAll") {
      if (checkedTextAIStatus.length === textAIStatusOptions.length) {
        setCheckedTextAIStatus([]);
        // setTextStatusFilter([]);
      } else {
        setCheckedTextAIStatus(textAIStatusOptions.map(opt => opt.value));
        // setTextStatusFilter(textStatusOptions);
      }
    } else {
      const isChecked = checkedTextAIStatus.includes(ele.value);
      let newCheckedItems;

      if (isChecked) {
        newCheckedItems = checkedTextAIStatus.filter(id => id !== ele.value);
      } else {
        newCheckedItems = [...checkedTextAIStatus, ele.value];
      }

      setCheckedTextAIStatus(newCheckedItems);
      const lists = textAIStatusOptions.filter(item =>
        newCheckedItems.includes(item.value)
      );
      // setTextStatusFilter(lists);
    }
  };

  const handleAbuseCheck = async (ele) => {
    if (ele === "selectAll") {
      // Check if all keywords are selected
      if (checkedAbuseTypes.length === abuseTypes.length) {
        setCheckedAbuseTypes([]); // Clear all selections
        // setAbuse_type([]);
      } else {
        setCheckedAbuseTypes(abuseTypes.map((k) => k.id)); // Select all
        setAbuse_type(abuseTypes);
        console.log("abuseTypes", abuseTypes);
      }
    } else {
      const isChecked = checkedAbuseTypes.includes(ele.id);
      let newCheckedItems;

      if (isChecked) {
        newCheckedItems = checkedAbuseTypes.filter((id) => id !== ele.id);
      } else {
        newCheckedItems = [...checkedAbuseTypes, ele.id];
      }
      // console.log("newCheckedItems", newCheckedItems)
      setCheckedAbuseTypes(newCheckedItems);
      // localStorage.removeItem('checked_Abuse_type');
      // localStorage.setItem('checked_Abuse_type', JSON.stringify(newCheckedItems));

      // Log checked platform IDs and names
      const lists = abuseTypes.filter((item) =>
        newCheckedItems.includes(item.id)
      );
      console.log("newCheckedItems", lists);

      //console.log('Checked Abuses:', lists);
      // localStorage.removeItem('checked_Abuse_type');
      // localStorage.setItem('checked_Abuse_type', JSON.stringify(lists.map((ele) => ({ id: ele.is_text, abuse_type: ele.abuse_type }))));
      // setAbuse_type(lists);
      // //console.log("current Location",location);
    }
  };
  const verifcationOptions = [
    { is_text: -1, name: "Text & image NOT match" },
    { is_text: 0, name: "Text NOT match & image match" },
    { is_text: 1, name: "Text match & image NOT match" },
    { is_text: 2, name: "Text & Image both Match" },
  ];

  const updatedVerificationOption = [
    { brand_image_check: "-1", name: "-1" },
    { brand_image_check: "0", name: "0" },
    { brand_image_check: "1", name: "1" },
    { brand_image_check: "null", name: "null" },
    { brand_image_check: "2", name: "2" },
    { brand_image_check: "3", name: "3" },
    { brand_image_check: "4", name: "4" },
    { brand_image_check: "5", name: "5" },
    { brand_image_check: "6", name: "6" },
  ];

  const textStatusOptions = [
    { value: "null", name: "Not Processed Yet" },
    { value: "-1", name: "Text Not Match" },
    { value: "0", name: "No Text" },
    { value: "1", name: "Text Match" }
  ];
  const textAIStatusOptions = [
    { value: "null", name: "Not Processed Yet" },
    { value: "-2", name: "Text Not Match" },
    { value: "-1", name: "Text Not Match" },
    { value: "0", name: "No Text" },
    { value: "1", name: "Text Match" }
  ];

  const handleLogOut = async () => {
    await localStorage.removeItem("PAuser");
    history.push("/");
  };

  const pathsForDates = [
    "/admin/dashboard",
    "/admin/uncrawled",
    "/admin/products",
    "/admin/suspicious",
    "/admin/test",
    "/admin/infringe",
  ];
  const pathsNotForFilter = [
    "/admin/dashboard",
    "/admin/og_image",
    "/admin/addurlmanually",
    "/admin/lookalike",
    "/admin/infringe",
    "/admin/globalproducts"
  ];

  let newRoutes = [];
  const clientRoutes = () => {
    newRoutes = routes.filter((item) => {
      return item.isAdmin !== true;
    });
    return newRoutes;
  };

  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
    >
      <SidebarResponsive routes={isAdmin ? routes : clientRoutes()} />
      {JSON.parse(localStorage.getItem("PAuser"))?.message?.isAdmin && (
        <Dropdown />
      )}

      <Menu>
        {pathsForDates.includes(location.pathname) && (
          <>
            <MenuButton p="0px">
              <Icon
                // mt='6px'
                as={MdCalendarMonth}
                color="gray.600"
                w="25px"
                h="25px"
                me="10px"
              />
            </MenuButton>
            <Portal>

              <MenuList
                boxShadow={shadow}
                p="10px"
                me={{ base: "10px", md: "unset" }}
                borderRadius="20px"
                bg={menuBg}
                border="none"
                mt="-50px"
                maxHeight="70vh"
                overflowY="auto"
                zIndex={9999}
              >
                <Flex flexDirection="row">
                  <Flex flexDirection="row" w="fit-content">
                    <Center>
                      <Text me="10px">From: </Text>
                    </Center>
                    <Input
                      placeholder="Select Date and Time"
                      size="md"
                      onChange={(e) =>
                        setDateFilter({
                          ...dateFilter,
                          startDate: e.target.value,
                        })
                      }
                      value={dateFilter.startDate}
                      type="date"
                    />
                  </Flex>
                  <Flex flexDirection="row" ms="15" w="fit-content">
                    <Center>
                      <Text me="10px">To: </Text>
                    </Center>
                    <Input
                      placeholder="Select Date and Time"
                      size="md"
                      onChange={(e) =>
                        setDateFilter({ ...dateFilter, endDate: e.target.value })
                      }
                      value={dateFilter.endDate}
                      type="date"
                    />
                  </Flex>
                </Flex>
              </MenuList>
            </Portal>
          </>
        )}
      </Menu>
      <Menu>
        {location.pathname === "/admin/dashboard" && (
          <>
            <MenuButton p="0px" onClick={() => sheetDownload(dateFilter)}>
              <Icon
                as={SiGooglesheets}
                color="gray.600"
                w="22px"
                h="22px"
                me="10px"
              />
            </MenuButton>
          </>
        )}
      </Menu>
      <Menu>
        {location.pathname === "/admin/dashboard" && (
          <Link
            href={`/report?dateFilter=${JSON.stringify(dateFilter)}&brand=${userName?.message?.result?.name
              }`}
            target="_blank"
          >
            <MenuButton p="0px">
              <Icon
                as={BsFileEarmarkBarGraphFill}
                color="gray.600"
                w="22px"
                h="22px"
                me="10px"
              />
            </MenuButton>
          </Link>
        )}
      </Menu>
      <Menu>
        {!pathsNotForFilter.includes(location.pathname) && (
          <>
            <MenuButton p="0px">
              <Icon
                mt="6px"
                as={MdFilterAlt}
                color="gray.600"
                w="25px"
                h="25px"
                me="10px"
              />
            </MenuButton>
            <Portal>

              <MenuList
                boxShadow={shadow}
                p="20px"
                me={{ base: "30px", md: "unset" }}
                borderRadius="20px"
                bg={menuBg}
                border="none"
                mt="22px"
                maxHeight="70vh" // Adjust the maxHeight as needed
                overflowY="auto"
                sx={{
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    bg: "gray.300",
                    borderRadius: "full",
                  },
                  "&::-webkit-scrollbar-track": {
                    bg: "gray.100",
                  },
                }}
                w={{ base: "360px", md: "unset" }}
                zIndex={80}
              >
                <Flex justifyContent="space-between" gap={5}>
                  {/* platforms */}
                  <Box>
                    <Heading as="h4" size="sm" textAlign="left">
                      Platforms
                    </Heading>
                    <Flex flexDirection="column">
                      <Checkbox
                        isChecked={checkedItems.length === platforms.length}
                        onChange={() => handlePlatformCheck("selectAll")}
                      >
                        Select all
                      </Checkbox>
                      {platforms.map((pf) => (
                        <Checkbox
                          key={pf.id}
                          isChecked={checkedItems.includes(pf.id)}
                          onChange={() => handlePlatformCheck(pf)}
                        >
                          {pf.platform_name}
                        </Checkbox>
                      ))}
                    </Flex>
                  </Box>
                  {/* keywords */}
                  <Box>
                    <Heading as="h4" size="sm" textAlign="left">
                      Keywords
                    </Heading>
                    <Flex flexDirection="column">
                      <Checkbox
                        isChecked={checkedKeywords.length === keywords.length}
                        onChange={() => handleKeywordCheck("selectAll")}
                      >
                        Select all
                      </Checkbox>
                      {keywords.map((pf) => (
                        <Checkbox
                          key={pf.id}
                          isChecked={checkedKeywords.includes(pf.id)}
                          onChange={() => handleKeywordCheck(pf)}
                        >
                          {pf.name}
                        </Checkbox>
                      ))}
                    </Flex>
                  </Box>
                  {/* verification status */}
                  {location.pathname === "/admin/uncrawled" && (
                    <Box>
                      <Heading as="h4" size="sm" textAlign="left">
                        Verification
                      </Heading>
                      <Flex flexDirection="column">
                        <Checkbox
                          isChecked={
                            checkedVerificationStatus.length ===
                            updatedVerificationOption.length
                          }
                          onChange={() => handleVerificationCheck("selectAll")}
                        >
                          Select all
                        </Checkbox>
                        {updatedVerificationOption.map((ele, index) => (
                          <Checkbox
                            key={index}
                            isChecked={checkedVerificationStatus.includes(
                              ele.brand_image_check
                            )}
                            onChange={() => handleVerificationCheck(ele)}
                          >
                            {ele.name}
                          </Checkbox>
                        ))}
                      </Flex>
                    </Box>
                  )}
                  {/* text status */}
                  {location.pathname === "/admin/uncrawled" && (
                    <Box>
                      <Heading as="h4" size="sm" textAlign="left">
                        Text Status
                      </Heading>
                      <Flex flexDirection="column">
                        <Checkbox
                          isChecked={
                            checkedTextStatus.length === textStatusOptions.length
                          }
                          onChange={() => handleTextStatusCheck("selectAll")}
                        >
                          Select all
                        </Checkbox>
                        {textStatusOptions.map((ele, index) => (
                          <Checkbox
                            key={index}
                            isChecked={checkedTextStatus.includes(ele.value)}
                            onChange={() => handleTextStatusCheck(ele)}
                          >
                            {ele.value}
                          </Checkbox>
                        ))}
                      </Flex>
                    </Box>
                  )}
                  {/* text ai status */}
                  {location.pathname === "/admin/uncrawled" && (
                    <Box>
                      <Heading as="h4" size="sm" textAlign="left">
                        Text AI Status
                      </Heading>
                      <Flex flexDirection="column">
                        <Checkbox
                          isChecked={
                            checkedTextAIStatus.length === textAIStatusOptions.length
                          }
                          onChange={() => handleTextAIStatusCheck("selectAll")}
                        >
                          Select all
                        </Checkbox>
                        {textAIStatusOptions.map((ele, index) => (
                          <Checkbox
                            key={index}
                            isChecked={checkedTextAIStatus.includes(ele.value)}
                            onChange={() => handleTextAIStatusCheck(ele)}
                          >
                            {ele.value}
                          </Checkbox>
                        ))}
                      </Flex>
                    </Box>
                  )}
                  {/* abuse status */}
                  {location.pathname === "/admin/suspicious" && (
                    <Box>
                      <Heading as="h4" size="sm" textAlign="left">
                        Abuse Types
                      </Heading>
                      <Flex flexDirection="column">
                        <Checkbox
                          isChecked={checkedAbuseTypes.length === abuseTypes.length}
                          onChange={() => handleAbuseCheck("selectAll")}
                        >
                          Select all
                        </Checkbox>
                        {abuseTypes.map((ele, index) => (
                          <Checkbox
                            key={index}
                            isChecked={checkedAbuseTypes.includes(ele.id)}
                            onChange={() => handleAbuseCheck(ele)}
                          >
                            {ele.abuse_type}
                          </Checkbox>
                        ))}
                      </Flex>
                    </Box>
                  )}


                </Flex>
              </MenuList>
            </Portal>
          </>
        )}
      </Menu>
      {/* <ThemeEditor navbarIcon={navbarIcon} /> */}
      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: "pointer" }}
            color="white"
            name={name}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              👋&nbsp; Hey, {name}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            {/* <MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} borderRadius="8px" px="14px">
							<Text fontSize="sm">Profile Settings</Text>
						</MenuItem>
						<MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} borderRadius="8px" px="14px">
							<Text fontSize="sm">Newsletter Settings</Text>
						</MenuItem> */}
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              color="red.400"
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm" onClick={handleLogOut}>
                Log out
              </Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};